export default "__VITE_ASSET__BOxp90zj__"